import DigitalAssetPagingResultModel from '../../generated/types/model/resource/DigitalAssetPagingResultModel';

export default class DigitalAssetPagingResultViewModel extends DigitalAssetPagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
